<template>
  <section v-if="pilotEnabled" class="customer-hub-courses" aria-label="Deine nächsten Kurse">
    <div class="course-heading">
      <h3>{{ nextCourse ? 'Als Nächstes' : 'Deine Kurse' }}</h3>
      <v-btn text small color="primary" to="/kurse">Kurs buchen <v-icon small right>mdi-arrow-right</v-icon></v-btn>
    </div>
    <v-progress-linear v-if="loading" indeterminate color="primary" height="2" />
    <button v-else-if="nextCourse" class="course-booking" type="button" @click="openDay">
      <v-icon color="primary" size="30">mdi-account-group-outline</v-icon>
      <span>
        <small>ANGEMELDET</small>
        <strong>{{ nextCourse.title }}</strong>
        <span>{{ $moment(nextCourse.startAt).format('dd, DD. MMM · HH:mm') }}<template v-if="nextCourse.studioName"> · {{ nextCourse.studioName }}</template></span>
      </span>
      <v-icon color="white">mdi-chevron-right</v-icon>
    </button>
    <p v-else-if="error" role="status">{{ error }} <button type="button" class="retry" @click="load">Erneut laden</button></p>
    <p v-else>Du hast noch keinen kommenden Kurs gebucht.</p>
  </section>
</template>

<script>
import customerHubApi from "@/api/customerHubApi"
import customerHubPreferences from "@/services/customerHubPreferences"
import { customerHubActivityLocation } from "@/services/customerHubNavigation"

export default {
  data() { return { loading: false, error: "", nextCourse: null, requestVersion: 0 } },
  computed: {
    pilotEnabled() { return customerHubPreferences.isEnabled() },
  },
  watch: {
    pilotEnabled(enabled) {
      if (enabled) this.load()
      else {
        this.requestVersion++
        this.nextCourse = null
        this.error = ""
        this.loading = false
      }
    },
  },
  created() { this.load() },
  beforeDestroy() { this.requestVersion++ },
  methods: {
    async load() {
      if (!customerHubPreferences.isEnabled()) return
      const version = ++this.requestVersion
      const { userId: owner, token } = customerHubPreferences.identity()
      const revision = customerHubPreferences.state.revision
      this.loading = true
      this.error = ""
      const activeRequest = () => version === this.requestVersion
      const current = () => activeRequest() && customerHubPreferences.isEnabled()
        && token === customerHubPreferences.identity().token
        && owner === customerHubPreferences.state.userId && revision === customerHubPreferences.state.revision
      try {
        const response = await customerHubApi.getUpcomingCourses(token)
        if (!current()) return
        if (response?.success !== true || String(response.userId || "") !== owner || !Array.isArray(response.activities)) {
          throw new Error("Invalid upcoming courses response")
        }
        this.nextCourse = response.activities
          .filter(course => course && new Date(course.startAt).getTime() >= Date.now())
          .sort((left, right) => new Date(left.startAt).getTime() - new Date(right.startAt).getTime())[0] || null
      } catch (error) {
        if (current()) {
          this.nextCourse = null
          this.error = "Deine Kursbuchungen konnten nicht geladen werden."
          if ([401, 403].includes(error?.response?.status)) customerHubPreferences.resolve(owner, token, [])
        }
      } finally {
        if (activeRequest()) this.loading = false
      }
    },
    openDay() {
      if (this.nextCourse && customerHubPreferences.isEnabled()) {
        this.$router.push(customerHubActivityLocation(this.$moment(this.nextCourse.startAt).format("YYYY-MM-DD")))
      }
    },
  },
}
</script>

<style scoped>
.customer-hub-courses { padding: 16px; margin: 18px 0; border: 1px solid #ffffff12; border-radius: 20px; background: #ffffff05; color: #fff; }
.course-heading { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.course-heading h3 { font-size: 16px; margin: 0; }
.course-booking { display: flex; align-items: center; gap: 14px; width: 100%; padding: 14px 0 0; text-align: left; color: #fff; }
.course-booking > span { flex: 1; min-width: 0; }
.course-booking small, .course-booking strong, .course-booking span span { display: block; }
.course-booking small { color: #a3c6c4; font-size: 10px; letter-spacing: 1px; }
.course-booking strong { font-size: 17px; margin: 3px 0; }
.course-booking span span, p { color: #bdbdbd; font-size: 13px; }
p { margin: 12px 0 0; }
.retry { color: #a3c6c4; text-decoration: underline; }
button:focus-visible { outline: 2px solid #a3c6c4; outline-offset: 4px; }
</style>
